module.exports = __webpack_public_path__ + "static/img/010.731d0cb0.png";